import _classCallCheck from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { getOriginalFunction } from '@sentry/utils';
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */

var FunctionToString =
/*#__PURE__*/
function () {
  _createClass(FunctionToString, null, [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'FunctionToString';
    }
    /**
     * @inheritDoc
     */

  }]);

  function FunctionToString() {
    _classCallCheck(this, FunctionToString);

    this.name = FunctionToString.id;
  }
  /**
   * @inheritDoc
   */


  _createClass(FunctionToString, [{
    key: "setupOnce",
    value: function setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString; // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)

      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
          var context = getOriginalFunction(this) || this;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {// ignore errors here, just don't patch this
      }
    }
  }]);

  return FunctionToString;
}();

FunctionToString.__initStatic();

export { FunctionToString };